// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.speed-chart {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 12px;

    width: 100%;
    height: 100%;
}

.speed-chart__title {
    font-weight: 600;
    font-size: 26px;
    line-height: 35px;
    text-align: center;

    color: #000000;
}

.speed-chart__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    width: 100%;
}

.speed-chart__subtitle {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-align: center;

    color: #000000;
    opacity: 0.5;
}

.speed-chart__average {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin-top: 4px;
}

.speed-chart__average-label {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #000000;
    opacity: 0.5;
}

.speed-chart__average-value {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #FFA825;
}

.speed-chart__axis-label {
    font-weight: 400;
    font-size: 11px;
    line-height: 14px;
    color: #000000;
    opacity: 0.5;
    text-align: left;
    width: 100%;
    margin-top: 4px;
}

.speed-chart__graph {
    width: 100%;
    height: 200px;
    position: relative;
}

.speed-chart__bottom {
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.speed-chart__bottom-a {
    font-weight: 400;
    font-size: 7px;
    line-height: 10px;
    color: #000000;
    opacity: 0.5;
}

.speed-chart__bottom-b {
    font-weight: 700;
    font-size: 7px;
    line-height: 10px;
    text-align: right;

    color: #000000;
    opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./src/components/chartjs/SpeedChart.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,aAAa;;IAEb,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;;IAElB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;;IAElB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;;IAEjB,cAAc;IACd,YAAY;AAChB","sourcesContent":["\n.speed-chart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    padding: 12px;\n\n    width: 100%;\n    height: 100%;\n}\n\n.speed-chart__title {\n    font-weight: 600;\n    font-size: 26px;\n    line-height: 35px;\n    text-align: center;\n\n    color: #000000;\n}\n\n.speed-chart__header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 5px;\n    width: 100%;\n}\n\n.speed-chart__subtitle {\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    text-align: center;\n\n    color: #000000;\n    opacity: 0.5;\n}\n\n.speed-chart__average {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    margin-top: 4px;\n}\n\n.speed-chart__average-label {\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    color: #000000;\n    opacity: 0.5;\n}\n\n.speed-chart__average-value {\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 18px;\n    color: #FFA825;\n}\n\n.speed-chart__axis-label {\n    font-weight: 400;\n    font-size: 11px;\n    line-height: 14px;\n    color: #000000;\n    opacity: 0.5;\n    text-align: left;\n    width: 100%;\n    margin-top: 4px;\n}\n\n.speed-chart__graph {\n    width: 100%;\n    height: 200px;\n    position: relative;\n}\n\n.speed-chart__bottom {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.speed-chart__bottom-a {\n    font-weight: 400;\n    font-size: 7px;\n    line-height: 10px;\n    color: #000000;\n    opacity: 0.5;\n}\n\n.speed-chart__bottom-b {\n    font-weight: 700;\n    font-size: 7px;\n    line-height: 10px;\n    text-align: right;\n\n    color: #000000;\n    opacity: 0.9;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
